import { useQuery } from '@tanstack/react-query';
import { KnownAccessControls } from 'app/business-logic/security/KnownAccessControls';
import { QUERY_KEY } from 'app/business-logic/services/query-key';
import { fetchResourceGroups } from 'app/business-logic/services/resource-group-services/fetchResourceGroups';
import { useHasAccess } from 'app/hooks/use-has-access';

export const useResourceGroups = () => {
  const hasAccess = useHasAccess();
  const hasResourceGroupsAccess = hasAccess(KnownAccessControls.app.config.resourceGroups._);
  const {
    data = [],
    isFetching,
    isLoading,
  } = useQuery({
    queryKey: [QUERY_KEY.resourceGroups],
    queryFn: fetchResourceGroups,
    staleTime: Infinity,
    enabled: hasResourceGroupsAccess,
  });
  return { data, isFetching, isLoading };
};
